import React, { useEffect, FC } from 'react';
import { update } from 'serializr';
import { action } from 'mobx';

import { useSocket } from '@vromo/websockets';
import { useStore } from '@vromo/mobx-react';
import { RootStore } from './stores/RootStore';

/** Configure websockets and perform some of the data fetching */
const StoreData: FC = ({ children }) => {
    const {
        authStore: { token, role, graph, api, status },
        siteStore,
        blueprintStore,
        roleStore,
        groupStore,
        policyStore,
        // accountStore,
        campaignStore,
        vehicleStore,
        jobStore
    } = useStore<RootStore>('rootStore');

    useEffect(() => {
        graph.root
            .graph()
            .roles(role.id)
            .sites()
            .get()
            .then((sites) => {
                siteStore.loaded = true;
                update(siteStore.sites, sites);
            });

        graph.root
            .graph()
            .roles(role.id)
            .blueprints()
            .get()
            .then((blueprints) => {
                blueprintStore.loaded = true;
                update(blueprintStore.blueprints, blueprints);
            });

        graph.root
            .graph()
            .roles(role.id)
            .account()
            .roles()
            .get()
            .then((roles) => {
                roleStore.loaded = true;
                update(roleStore.roles, roles);
            });

        // Grab Account status on reload
        if (role) {
            api.account.get({ group: role.group?.id }, {}, token!).then(
                action((accountStatus) => {
                    update(status, accountStatus);
                })
            );
        }
    }, []);

    useSocket(
        graph.root.graph().roles(role.id).groups().socketUrl(),
        groupStore.groups,
        () => (groupStore.loaded = true)
    );

    useSocket(
        graph.root.graph().roles(role.id).campaigns().socketUrl(),
        campaignStore.campaigns,
        () => (campaignStore.loaded = true)
    );

    useSocket(
        graph.root.graph().roles(role.id).dashboard().socketUrl(),
        policyStore.policies,
        () => (policyStore.loaded = true),
        ({ policies }) => policies
    );

    useSocket(
        graph.root.graph().roles(role.id).dashboard().socketUrl(),
        vehicleStore.vehicles,
        () => (vehicleStore.loaded = true),
        ({ vehicles }) => vehicles
    );

    useSocket(
        graph.root.graph().roles(role.id).dashboard().socketUrl(),
        jobStore.jobs,
        () => {
            jobStore.loaded = true;
        },
        ({ jobs }) => jobs
    );

    return <>{children}</>;
};

export default StoreData;
